import React from 'react';
import { InputWidgetState } from '@kemu-io/kemu-core/types';
// import {sendToInputWidgets} from '@kemu-io/kemu-core/processor';
import Icon from '@ant-design/icons';
import { Dropdown, Tooltip } from 'antd';
import InputWidgetProcessor, {
	getDefaultState,
} from '@kemu-io/kemu-core/widgets/input/index.js';
import { DataType } from '@kemu-io/hs-types';
import classNames from 'classnames';
import {
  GateUI,
	GateUIProps,
  GetPortsInformationFunction
} from '../index.js';
import { buildOutputPortsDescription } from '../common';
import styles from './InputWidget.module.css';
import TextInput from '@components/WidgetsComponents/TextInput/TextInput';
import useReactiveWidgetState from '@hooks/useReactiveWidgetState';
import GateIcon from '@components/gateIcon/gateIcon';
import { ReactComponent as InputWidgetIcon } from '@src/assets/img/gates/input-widget.svg';
import DataTypeIcon from '@components/DataTypeIcon/DataTypeIcon';

import useTranslation from '@hooks/useTranslation';

type Props = GateUIProps


const InputWidget = (props: Props) => {
  const [state, setState] = useReactiveWidgetState<InputWidgetState>(props.recipeId, props.thingRecipeId, props.info.id);
  const t = useTranslation('Kemu.DataType.HumanReadable');
  const inputT = useTranslation('Widget.Input');

	const fixedState = {
		...getDefaultState(),
		...state
	};

  const updateName = (name: string) => {
    setState((s) => ({
      ...s,
      inputName: name,
    }));
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onUpdateType = ({ key }: any) => {
    setState((s) => ({
      ...s,
      dataType: Number(key),
    }));
  };

  // const handleSendTestEvent = () => {
  //   sendToInputWidgets({
  //     inputName: fixedState.inputName, 
  //     data: {
  //       type: DataType.Anything,
  //       value: 'testing',
  //     }, 
  //     recipePoolId: props.recipeId, 
  //     thingId: props.thingRecipeId,
  //     waitForOutputChild: true,
  //   });
  // };

  return (
    <div className={styles.InputWrapper}>
      {/* <button onClick={handleSendTestEvent}>Test</button> */}
      <TextInput
        value={fixedState.inputName}
        placeholder={inputT('Placeholder')}
        onChange={(e) => updateName(e.currentTarget.value)}
      />

      <Dropdown
        menu={{
          onClick: onUpdateType,
          items: [
            {
              key: DataType.Number,
              label: t('Number'),
              icon: <DataTypeIcon dataType={DataType.Number} />,
            },
            {
              key: DataType.String,
              label: t('String'),
              icon: <DataTypeIcon dataType={DataType.String} />,
            },
            {
              key: DataType.Array,
              label: t('Array'),
              icon: <DataTypeIcon dataType={DataType.Array} />,
            },
            {
              key: DataType.JsonObj,
              label: t('JsonObj'),
              icon: <DataTypeIcon dataType={DataType.JsonObj} />,
            },
            {
              key: DataType.ImageData,
              label: t('ImageData'),
              icon: <DataTypeIcon dataType={DataType.ImageData} />,
            },
            {
              key: DataType.Boolean,
              label: t('Boolean'),
              icon: <DataTypeIcon dataType={DataType.Boolean} />,
            },
            {
              key: DataType.Rect,
              label: t('Rect'),
              icon: <DataTypeIcon dataType={DataType.Rect} />,
            },
            {
              key: DataType.BinaryFile,
              label: t('BinaryFile'),
              icon: <DataTypeIcon dataType={DataType.BinaryFile} />,
            },
            {
              key: DataType.ArrayBuffer,
              label: t('ArrayBuffer'),
              icon: <DataTypeIcon dataType={DataType.ArrayBuffer} />,
            },
            {
              key: DataType.AudioBuffer,
              label: t('AudioBuffer'),
              icon: <DataTypeIcon dataType={DataType.AudioBuffer} />,
            },
            {
              key: DataType.Anything,
              label: t('Anything'),
              icon: <DataTypeIcon dataType={DataType.Anything} />,
            },
          ]
        }}
        placement="bottomLeft"
        trigger={['click']}
      >
        <Tooltip title={inputT('DataTypeTooltip')}>
          <span className={classNames(styles.ChooseType, `type-${fixedState.dataType}`)} >
            <DataTypeIcon dataType={fixedState.dataType} />
          </span>
        </Tooltip>
      </Dropdown>
    </div>
  );
};

/** Icon to be added to the bar */
const GateBarIcon = (): React.JSX.Element => {
	return (
		<GateIcon icon={<Icon component={InputWidgetIcon} />}/>
	);
};


const getPortsInformation: GetPortsInformationFunction = (state, widgetInfo) => {
	const outputNames = InputWidgetProcessor.getOutputNames(state, widgetInfo);
	const outputs = buildOutputPortsDescription(outputNames, 0.5);

	return {
		inputs: [],
		outputs,
	};
};

export default {
	getPortsInformation,
  hasTitle: true,

	BarIcon: GateBarIcon,
	Element: InputWidget,
	getGatesBarTitle: (intl) => intl.formatMessage({ id: 'Widget.Input.Title' }),
} as GateUI;
